export type AppBuildMeta = {
  version: string;
  builtAt: string;
};

export const currentAppBuild: AppBuildMeta = {
  version: __APP_VERSION__,
  builtAt: __APP_BUILT_AT__,
};

function isAppBuildMeta(value: unknown): value is AppBuildMeta {
  if (!value || typeof value !== "object") {
    return false;
  }

  const candidate = value as Partial<AppBuildMeta>;
  return (
    typeof candidate.version === "string" &&
    candidate.version.length > 0 &&
    typeof candidate.builtAt === "string" &&
    candidate.builtAt.length > 0
  );
}

export function isNewerAppBuild(latestBuild: AppBuildMeta | null | undefined) {
  return Boolean(latestBuild && latestBuild.version !== currentAppBuild.version);
}

export async function fetchLatestAppBuild(): Promise<AppBuildMeta | null> {
  if (!import.meta.env.PROD) {
    return currentAppBuild;
  }

  const buildMetaUrl = new URL("/build-meta.json", window.location.origin);
  buildMetaUrl.searchParams.set("t", Date.now().toString());

  const response = await fetch(buildMetaUrl.toString(), {
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch build metadata (${response.status})`);
  }

  const data: unknown = await response.json();

  if (!isAppBuildMeta(data)) {
    return null;
  }

  return data;
}
